import { Form, Input, InputNumber } from "antd";
import React from "react";
import "./index.scss";
const { TextArea } = Input;
import { CKEditor, ClassicEditor } from "ckeditor4-react";
import { useState } from "react";
import { TagsInput } from "react-tag-input-component";
const MenuLeft = ({ lang, onChangeContentValue, content, id = '' }) => {
    return (
        <>
            <Form.Item label="Title" name={`title_${lang}`}>
                <TextArea autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="Slug" name={`sub_title_${lang}`}>
                <Input />
            </Form.Item>
            <Form.Item label="Content">
                {content.content_vi || content.content_kr || content.content_en || !id ? (
                    <CKEditor
                        initData={content['content_' + lang] ?? ""}
                        name={`content_${lang}`}
                        onChange={(e) => {
                            onChangeContentValue({
                                name: "content_" + lang,
                                content: e.editor.getData(),
                            });
                        }}
                        config={{
                            toolbarGroups: [
                                {
                                    name: "document",
                                    groups: ["mode", "document", "doctools"],
                                },
                                {
                                    name: "clipboard",
                                    groups: ["clipboard", "undo"],
                                },
                                {
                                    name: "editing",
                                    groups: [
                                        "find",
                                        "selection",
                                        "spellchecker",
                                        "editing",
                                    ],
                                },
                                { name: "forms", groups: ["forms"] },
                                {
                                    name: "basicstyles",
                                    groups: ["basicstyles", "cleanup"],
                                },
                                {
                                    name: "paragraph",
                                    groups: [
                                        "list",
                                        "indent",
                                        "blocks",
                                        "align",
                                        "bidi",
                                        "paragraph",
                                    ],
                                },
                                { name: "links", groups: ["links"] },
                                { name: "insert", groups: ["insert"] },
                                { name: "styles", groups: ["styles"] },
                                { name: "colors", groups: ["colors"] },
                                { name: "tools", groups: ["tools"] },
                                { name: "others", groups: ["others"] },
                                { name: "about", groups: ["about"] },
                            ],
                            filebrowserBrowseUrl: '/ckfinder/browser',
                            filebrowserImageBrowseUrl: "/ckfinder/browser?type=Images&token=123",
                            filebrowserFlashBrowseUrl: "/ckfinder/browser?type=Flash&token=123",
                            // filebrowserUploadUrl:"/api/v1/client/store-image",
                            // filebrowserUploadMethod: 'form',
                            filebrowserUploadUrl: "/ckfinder/connector?command=QuickUpload&type=Files",
                            filebrowserImageUploadUrl: "/ckfinder/connector?command=QuickUpload&type=Images",
                            filebrowserFlashUploadUrl: "/ckfinder/connector?command=QuickUpload&type=Flash",
                            height: 300,
                        }}
                    />
                ) : (
                    <></>
                )}

            </Form.Item>
            <Form.Item label="Gia san pham" name={`price`}>
                <TextArea autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="Gia sau giam" name={`discount`}>
                <TextArea autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="Shopee" name={`shopee`}>
                <TextArea autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="Lazada" name={`lazada`}>
                <TextArea autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="So luong trong kho" name={`totalStore`}>
                <InputNumber />
            </Form.Item>
            <Form.Item label="Kiểu, loại sản phẩm" name={`styleProduct`}>
                <TagsInput />
            </Form.Item>
            <Form.Item label="Màu sắc" name={`colorProduct`}>
                <TagsInput
                />
            </Form.Item>
            <Form.Item label="So luong da ban" name={`numberBuy`}>
                <InputNumber />
            </Form.Item>
        </>
    );
};
export default MenuLeft;
